import { getStoreByMailboxInfo } from "../store/store";
import type { MailboxInfo } from "owa-client-types";
import type ReportSubmissionPolicy from "../types/ReportSubmissionPolicy";

export default function getReportSubmissionPolicy(mailboxInfo: MailboxInfo): ReportSubmissionPolicy {
    return getStoreByMailboxInfo(mailboxInfo).reportSubmissionPolicy;
}
